// A collection of date utilities

import { add, isSameDay } from 'date-fns' // eslint-disable-line import/no-unresolved
import _ from "underscore"

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

var dateFormat = (function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
        timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[\-+]\d{4})?)\b/g,
        timezoneClip = /[^\-+\dA-Z]/g,
        pad = function (val, len) {
            val = String(val);
            len = len || 2;
            while (val.length < len) { val = "0" + val; }
            return val;
        };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
        // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
        if (arguments.length === 1 && Object.prototype.toString.call(date) === "[object String]" && !/\d/.test(date)) {
            mask = date;
            date = undefined;
        }

        // Passing date through Date applies Date.parse, if necessary
        date = date ? new Date(date) : new Date();
        if (isNaN(Number(date))) { throw new SyntaxError("invalid date"); }

        mask = String(dateFormat.masks[mask] || mask || dateFormat.masks["default"]);

        // Allow setting the utc argument via the mask
        if (mask.slice(0, 4) === "UTC:") {
            mask = mask.slice(4);
            utc = true;
        }

        var getPrefix = utc ? "getUTC" : "get",
            d = date[getPrefix + "Date"](),
            D = date[getPrefix + "Day"](),
            m = date[getPrefix + "Month"](),
            y = date[getPrefix + "FullYear"](),
            H = date[getPrefix + "Hours"](),
            M = date[getPrefix + "Minutes"](),
            s = date[getPrefix + "Seconds"](),
            L = date[getPrefix + "Milliseconds"](),
            o = utc ? 0 : date.getTimezoneOffset(),
            flags = {
                d:    d,
                dd:   pad(d),
                ddd:  dateFormat.i18n.dayNames[D],
                dddd: dateFormat.i18n.dayNames[D + 7],
                m:    m + 1,
                mm:   pad(m + 1),
                mmm:  dateFormat.i18n.monthNames[m],
                mmmm: dateFormat.i18n.monthNames[m + 12],
                yy:   String(y).slice(2),
                yyyy: y,
                h:    H % 12 || 12,
                hh:   pad(H % 12 || 12),
                H:    H,
                HH:   pad(H),
                M:    M,
                MM:   pad(M),
                s:    s,
                ss:   pad(s),
                l:    pad(L, 3),
                L:    pad(L > 99 ? Math.round(L / 10) : L),
                t:    H < 12 ? "a"  : "p",
                tt:   H < 12 ? "am" : "pm",
                T:    H < 12 ? "A"  : "P",
                TT:   H < 12 ? "AM" : "PM",
                Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 !== 10) * d % 10]
            };

        return mask.replace(token, function ($0) {
            return _.has(flags,$0) ? flags[$0] : $0.slice(1, $0.length - 1);
        });
    };
}());

// Some common format strings
dateFormat.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
    isoUtcDateTimeNoTZ: "UTC:yyyy-mm-dd'T'HH:MM:ss"
};

// Internationalization strings
dateFormat.i18n = {
    dayNames: [
        "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
};

/**
 * Returns a formatted version of the given date, corresponding to the specified mask.
 * The odd name is the result of there being another formatDate() function in twistle.js.
 * @param  {Date} date The date to format.
 * @param  {string} mask The format string for the date.
 * @param  {boolean?} utc Whether the return value should be represented in UTC time.
 */
export function betterFormatDate(date, mask, utc) {
    return dateFormat(date, mask, utc);
}

/**
 * Returns a string representation of the amount of time elapsed since the Date.
 */
export function timeAgoInWords(date, short) {
        // if we have a string, parse it, otherwise assume it's a date object
    if (typeof(date) === "string") {
        date = new Date(Date.parse(date));
    }
    var cdate = new Date();
    var diffms = cdate.getTime() - date.getTime();
    var diffminutes = diffms / (1000 * 60);
    var elapsedmin;
    var elapsedhours;

    if (diffminutes < 1) {
        return short ? "now" : "just now";
    }

    // less than an hour ?
    if (diffminutes < 60) {
        elapsedmin = Math.floor(diffms / (1000 * 60));
        if(short)
        {
            return elapsedmin + "m";
        }

        if (elapsedmin < 8) {
            return "a few minutes ago";
        }

        return elapsedmin + " minutes ago";

    }

    // less than 2 hours ?
    if (diffminutes < 120) {
        elapsedmin = Math.floor(diffms / (1000 * 60) - 60);
        return short ? "1h+" : ("1 hour " + elapsedmin + " minutes ago");
    }

    // less than 12 hours ?
    if (diffminutes < 720) {
        elapsedhours = Math.floor(diffms / (1000 * 60 * 60));
        return elapsedhours + (short ? "h" : " hours ago");
    }

    // less than 7 days ago
    if (diffminutes < 10080) {
        var elapseddays = Math.floor((cdate - date) / (1000 * 60 * 60 * 24));

        // >12hours but still today
        if (elapseddays === 0) {
            elapsedhours = Math.floor(diffms / (1000 * 60 * 60));
            return elapsedhours + (short ? "h" : " hours ago");
        }

        if (elapseddays === 1) {
            return short ? "1d" : "yesterday";
        }

        return elapseddays + (short ? "d" : " days ago");
    }

    // otherwise, for now, just show month day (+ year if not this year)
    if (date.getYear() !== cdate.getYear()) {
        return betterFormatDate(date, short ? "m/d yy" : "mmm d, yyyy");
    }

    return betterFormatDate(date, short ? "m/d" : "mmm d");
}

/**
 * Returns a Date object that is set to a time that is 'seconds' seconds from now.
 * Pass in a negative value to get a date from the past.
 * @param  {number} seconds The number of seconds from now that the returned date will be.
 */
export function dateWithSecondsFromNow(seconds) {
    return add(new Date(), {seconds: seconds});
}

/**
 * Determines if the specified date or string represents today, as
 * determined by whether its day of month, month, and full year
 * match the current date's values.
 * @param  {object} input A string or Date object.
 * @returns {boolean} Whether the specified input represents today.
 */
export function isToday(input) {
    if (typeof(input) === "string") {
        input = new Date(Date.parse(input));
    }
    return isSameDay(input, new Date());
}

export function isCurrentDateTimeDST(){
    const now = new Date(),
        jan = new Date(now.getFullYear(), 0, 1),
        jul = new Date(now.getFullYear(), 6, 1),
        stdOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    return now.getTimezoneOffset() < stdOffset;
}